var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3705 12.3926C27.3705 19.3018 22.1164 24.2188 14.3572 24.2188C6.91796 24.2188 0.910156 18.8086 0.910156 12.1094C0.910156 5.41016 6.91796 0 14.3572 0C17.9793 0 21.0266 1.19629 23.3744 3.16895L19.7144 6.33789C14.9266 2.17773 6.0233 5.30273 6.0233 12.1094C6.0233 16.333 9.77005 19.7559 14.3572 19.7559C19.6818 19.7559 21.6772 16.3184 21.9917 14.5361H14.3572V10.3711H27.1591C27.2838 10.9912 27.3705 11.5869 27.3705 12.3926Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a0ac9fb5ed392f11f0520a93c7139fcc.svg";
export { ForwardRef as ReactComponent };